module.exports = __webpack_public_path__ + "static/media/logoOnlyNegative.7c11737c.svg";